import { Alert, Button, Col, Row } from "react-bootstrap";
import type { IWorkbookInspectionResponse } from "../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";
import type { ISpreadsheetTemplateActive } from "../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";
import { TemplateUploadPanel } from "./TemplateUploadPanel";
import { WorkbookInspectionSummary } from "./WorkbookInspectionSummary";

export interface WasteReturnUploadStepProps {
    activeTemplate: ISpreadsheetTemplateActive | null;
    inspectionResponse: IWorkbookInspectionResponse | null;
    loadingActive: boolean;
    loadingInspection: boolean;
    refreshingInspection: boolean;
    uploading: boolean;
    uploadError: string | null;
    activeError: string | null;
    inspectionError: string | null;
    onUpload: (file: File, name: string) => Promise<boolean>;
    onClearUploadError: () => void;
    onRefreshInspection: () => void;
    onContinue?: () => void;
    canContinue?: boolean;
}

export function WasteReturnUploadStep({
    activeTemplate,
    inspectionResponse,
    loadingActive,
    loadingInspection,
    refreshingInspection,
    uploading,
    uploadError,
    activeError,
    inspectionError,
    onUpload,
    onClearUploadError,
    onRefreshInspection,
    onContinue,
    canContinue = false,
}: WasteReturnUploadStepProps) {
    return (
        <>
            <TemplateUploadPanel
                activeTemplate={activeTemplate}
                loading={loadingActive}
                uploading={uploading}
                uploadError={uploadError}
                activeError={activeError}
                onUpload={onUpload}
                onClearUploadError={onClearUploadError}
            />

            <WorkbookInspectionSummary
                inspectionResponse={inspectionResponse}
                loading={loadingInspection}
                refreshing={refreshingInspection}
                error={inspectionError}
                hasActiveTemplate={!!activeTemplate}
                onRefresh={onRefreshInspection}
            />

            {activeTemplate && onContinue && (
                <Row className="mb-4 justify-content-end">
                    <Col xs="auto">
                        <Button variant="primary" onClick={onContinue} disabled={!canContinue || uploading}>
                            Continue to map fields
                        </Button>
                    </Col>
                </Row>
            )}

            {!activeTemplate && !loadingActive && (
                <Alert variant="info">Upload a template workbook to begin the import journey.</Alert>
            )}
        </>
    );
}
